/**
 * Ticket 114.3 — useDemoCountries hook.
 *
 * Loads the active country catalog for the Demos module.
 */

import { useEffect, useState } from 'react';
import { listDemoCountries, type DemoCountry } from '@/api/demos';

export function useDemoCountries() {
  const [countries, setCountries] = useState<DemoCountry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    listDemoCountries()
      .then(setCountries)
      .catch(() => setError('demos.catalog.countries.loadError'))
      .finally(() => setLoading(false));
  }, []);

  return { countries, loading, error };
}
